import { c as _c } from "react/compiler-runtime";
import { Route, RouteProps } from 'react-router';
import useTitle from '../hooks/useTitle';
interface ViewRouteProps extends RouteProps {
  title?: string;
  subtitle?: string;
  usePathAsTitle?: boolean;
  capitalizeSubtitle?: boolean;
}
const ViewRoute = t0 => {
  const $ = _c(13);
  let capitalizeSubtitle;
  let routeProps;
  let subtitle;
  let title;
  let usePathAsTitle;
  if ($[0] !== t0) {
    ({
      title,
      usePathAsTitle,
      subtitle,
      capitalizeSubtitle,
      ...routeProps
    } = t0);
    $[0] = t0;
    $[1] = capitalizeSubtitle;
    $[2] = routeProps;
    $[3] = subtitle;
    $[4] = title;
    $[5] = usePathAsTitle;
  } else {
    capitalizeSubtitle = $[1];
    routeProps = $[2];
    subtitle = $[3];
    title = $[4];
    usePathAsTitle = $[5];
  }
  let t1;
  if ($[6] !== capitalizeSubtitle || $[7] !== subtitle || $[8] !== title || $[9] !== usePathAsTitle) {
    t1 = {
      title,
      subtitle,
      usePath: usePathAsTitle,
      capitalizeSubtitle
    };
    $[6] = capitalizeSubtitle;
    $[7] = subtitle;
    $[8] = title;
    $[9] = usePathAsTitle;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  useTitle(t1);
  let t2;
  if ($[11] !== routeProps) {
    t2 = <Route {...routeProps} />;
    $[11] = routeProps;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default ViewRoute;